import { useSelector } from "react-redux";

export const useAdaptedSurveyFields = () => {
    const rawFields = useSelector((state) => state.surveyFields.categories);
    const fieldOptions = useSelector((state) => state.fieldOptions.options);

    const typeMap = {
        string: "text",
        text: "textarea",
        datetime: "datetime",
        int: "number",
        float: "number",
        boolean: "boolean",
        single_choice_enum: "dropdown",
        multi_value: "multi_value",
        string_array: "string_array",
        double_input: "double_input"
    };

    const adaptFieldsFromApi = () => {
        if (!Array.isArray(rawFields)) return [];

        return rawFields.map((category) => ({
            category: category.category,
            categoryAttention: category.note,
            fields: category.fields.map((field) => {
                const isUrl = typeof field.options === "string";
                const resolvedOptions = isUrl ? fieldOptions[field.name] || [] : field.options;

                const isVirtualSubfield = typeof field.key === "string" && field.key.includes(".*.");

                return {
                    label: field.label || field.alias || field.name,
                    name: field.name,
                    type: typeMap[field.type] || "text",
                    options: resolvedOptions,
                    validationRules: { required: field.required === true },
                    fieldStructure: field,
                    isVirtualSubfield,
                };
            })
        }));
    };

    return adaptFieldsFromApi();
}